import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { EndpointKey } from '../http/EndpointKey';
import { getCurrentStep } from '../store/flow/selectors';
import { setEndpointTimeStarted } from '../store/http-responses/action-creators';
import { getHttpResponse } from '../store/http-responses/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getGTKMDomainToUse } from './gtkmDomainUtils';
import { getDomainFromEmail } from '../utils/getDomainFromEmail';
import { getGTKMEndpointKey } from '../utils/gtkm/getGTKMEndpointKey';
const fetchGTKMCompanyInfo = domain => {
  const COMPANY_INFO_URL = 'acquisition/v1/companyinfo/gtkm-data';
  return noAuthApiClient.get(`${COMPANY_INFO_URL}?domain=${domain}`, {
    timeout: 8000
  });
};
export const getGTKMCompanyInfoClient = (state, dispatch) => {
  const endpointKey = getGTKMEndpointKey(state);
  const domain = getGTKMDomainToUse(state);
  dispatch(setEndpointTimeStarted(endpointKey, new Date()));
  return fetchGTKMCompanyInfo(domain);
};
const checkFieldsInAnObject = (fields, object) => {
  return fields.every(field => Object.prototype.hasOwnProperty.call(object, field));
};
export const isErrorResponse = response => {
  return Boolean(response) && typeof response === 'object' && checkFieldsInAnObject(['status', 'message', 'data'], response);
};
export const getGTKMCompanyInfo = (state, dispatch) => {
  const httpResponse = getHttpResponse(state, EndpointKey.GTKMCompanyInfo);
  const currentStep = getCurrentStep(state);
  if (httpResponse && currentStep === Step.LoadingPage) {
    if (isErrorResponse(httpResponse)) {
      return Promise.reject(httpResponse);
    } else {
      return Promise.resolve(httpResponse);
    }
  }
  return getGTKMCompanyInfoClient(state, dispatch);
};
export const GTKMWithSignupDataDomain = state => {
  const domain = getSignupDataValue(state, Data.CompanyDomain);
  const domainValueToUse = domain === 'hubspot.com' ? 'hubspot-test.com' : domain;
  return fetchGTKMCompanyInfo(domainValueToUse);
};
export const GTKMWithDomainFromEmail = state => {
  const email = getSignupDataValue(state, Data.Email);
  const domain = getDomainFromEmail(email);
  const domainValueToUse = domain === 'hubspot.com' ? 'hubspot-test.com' : domain;
  return fetchGTKMCompanyInfo(domainValueToUse);
};